export function DollarHeartIcon(props) {
  const { ...imgAttrs } = props;

  return (
    <img 
      {...imgAttrs}
      className={`profile-icon profile-icon__dollar-heart ${imgAttrs.className ? imgAttrs.className : ""}`} 
      src={"https://wvusstatic.com/illustrations/dollars-heart.svg"} 
    />
  )
}

export default DollarHeartIcon;